import type { ListFigure } from '@/common/api/models/listFigure';
import type { MetricsResponseFiguresItem } from '@/common/api/models/metricsResponseFiguresItem';
import type { NumberFigure } from '@/common/api/models/numberFigure';
import type { PointsFigure } from '@/common/api/models/pointsFigure';

export function findFigure(
  figures: MetricsResponseFiguresItem[] | undefined,
  name: string,
): MetricsResponseFiguresItem | undefined {
  return figures?.find((f) => f.name === name);
}

export function asNumberFigure(
  figure: MetricsResponseFiguresItem | undefined,
): NumberFigure | undefined {
  if (!figure || figure.shape !== 'number') return undefined;
  return figure;
}

export function asPointsFigure(
  figure: MetricsResponseFiguresItem | undefined,
): PointsFigure | undefined {
  if (!figure || figure.shape !== 'points') return undefined;
  return figure;
}

export function asListFigure(
  figure: MetricsResponseFiguresItem | undefined,
): ListFigure | undefined {
  if (!figure || figure.shape !== 'list') return undefined;
  return figure;
}
